import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('BackgroundJobs.BackgroundJobs.deleteConfirmTitle'),
      "open": _vm.deletePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.delete'),
        color: _vm.color,
        emit: 'delete'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.deletePrompt = false;
      },
      "delete": _vm.deleteItem
    }
  }), _vm.isEmptyList ? [_c('core-n20Card', [_c('core-empty-state', {
    attrs: {
      "icon": "fa-sensor-on",
      "color": _vm.color
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n          " + _vm._s(_vm.$i18n_t('BackgroundJobs.BackgroundJobs.noIotHubExportJobs')) + "\n        ")];
      },
      proxy: true
    }], null, false, 3277309868)
  })], 1)] : [_c(VDataTable, {
    attrs: {
      "items": _vm.list,
      "loading": _vm.isFetching,
      "server-items-length": _vm.serverItemsLength,
      "options": _vm.tableOptions,
      "headers": _vm.tableLocalizations.headers,
      "footer-props": _vm.tableLocalizations.footerProps,
      "item-key": "id"
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item.startedAt",
      fn: function ({
        item
      }) {
        return [_c('span', [_vm._v("\n          " + _vm._s(_vm.localizeDate(item.startedAt)) + "\n        ")])];
      }
    }, {
      key: "item.stoppedAt",
      fn: function ({
        item
      }) {
        return [_c('span', [_vm._v("\n          " + _vm._s(_vm.localizeDate(item.stoppedAt)) + "\n        ")])];
      }
    }, {
      key: "item.createdAt",
      fn: function ({
        item
      }) {
        return [_c('span', [_vm._v("\n          " + _vm._s(_vm.localizeDate(item.createdAt)) + "\n        ")])];
      }
    }, {
      key: "item.actions",
      fn: function ({
        item
      }) {
        return [item.state === 'done' ? _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": "Download",
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.downloadItem(item);
            }
          }
        }, [_vm._v("\n          fal fa-download\n        ")]) : _vm._e(), _vm._v("\n         \n        "), _vm.isIotHubRead && (item.state === 'queued' || item.state === 'done') ? _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.showDeletePrompt(item);
            }
          }
        }, [_vm._v("\n          fal fa-trash-alt\n        ")]) : _vm._e()];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_vm._v("\n        " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n      ")];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n        ")])];
      },
      proxy: true
    }])
  })]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };